import styled, { keyframes } from 'styled-components';
import { SvgWrapper } from '../../svg';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const AlertStyled = styled.div`
  display: flex;
  align-items: center;

  animation: ${fadeIn} 0.15s linear;

  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fonts.literata};
  font-size: 14px;
  line-height: 20px;

  position: relative;
  padding: 20px;
  margin-bottom: ${props => (props.noMargin ? 0 : '20px')};

  border-radius: 3px;
  background-color: ${props => props.color};

  word-wrap: break-word;

  ${SvgWrapper} {
    margin-right: 10px;
  }
`;
